<template>
  <div>
    <b-alert :show="!demand && !publisher && !exchange" variant="primary">
      Please create a demand, publisher, or network profile
    </b-alert>
      <b-row>
        <b-col md="4">
          <b-card class="profile bg-light mx-auto mb-2">
            <div class="text-center">
              <h4>Demand</h4>
              <i class="fab fa-buffer fa-3x text-border" :class="{ 'text-demand': demand != null }"></i>
              <div>
                <b-btn :to="{ name: 'DemandSettings', params:{ cid: companyId }}"
                  variant="light" class="btn-sm mt-2">
                  {{ demand ? 'Settings' : 'Enable' }}
                </b-btn>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="profile bg-light mx-auto mb-2">
            <div class="text-center">
              <h4>Publisher</h4>
              <i class="fas fa-newspaper fa-3x text-border" :class="{ 'text-publisher': publisher != null }"></i>
              <div>
                <b-btn :to="{ name: 'PublisherSettings', params: { cid: companyId } }"
                       variant="light"  class="btn-sm mt-2">
                  {{ publisher ? 'Settings' : 'Enable' }}
                </b-btn>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="profile bg-light mx-auto mb-2">
            <div class="text-center">
              <h4>Exchange</h4>
              <i class="fas fa-exchange-alt fa-3x text-border" :class="{ 'text-admin': exchange != null }"></i>
              <div>
                <b-btn :to="{ name: 'ExchangeSettings', params: { cid: companyId } }"
                  variant="light" class="btn-sm mt-2">
                  {{ exchange ? 'Settings' : 'Enable' }}
                </b-btn>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    <company-settings :cid="companyId" class="mt-4"/>
    <account-list
      to-route="AdminAccountEdit"
      :cid="this.cid" class="mt-4"/>
  </div>
</template>

<script>
  import auth from '@/auth'
  import AccountList from '@/accounts/pages/AccountList'
  import CompanySettings from "./CompanySettings"
  import { ExchangeApi } from "../../exchange/api"
  import { DemandApi} from "../../demand/api"
  import { PublisherApi } from "../../publisher/api"


  export default {
      name: 'CompanyProfile',
      props: {
          cid: { required: false }
      },
      data () {
          return {
              exchange: null,
              demand: null,
              publisher: null
          }
      },
      created () {
          DemandApi.details(this.companyId)
              .then((demand) => this.demand = demand)
              .catch((e) => console.log("No demand profile"))
          PublisherApi.publisherDetails(this.companyId)
              .then((pub) => this.publisher = pub)
              .catch((e) => console.log("No pub profile"))
          ExchangeApi.details(this.companyId)
              .then((ex) => this.exchange = ex)
              .catch((e) => console.log("No exchange profile"))
      },
      computed: {
          companyId () {
              return this.cid ? this.cid : auth.details().company_id
          }
      },
      components: {
          AccountList,
          CompanySettings
      }
  }
</script>

<style scoped>
  .profile {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/company/pages/CompanyProfile.vue